module.exports = __webpack_public_path__ + "img/google-oauth2.logo.b7727941.svg";